// src/redux/agentSlice.js
import { createSlice } from "@reduxjs/toolkit";

const agentSlice = createSlice({
  name: "agent",
  initialState: {
    selectedAgent: null,
  },
  reducers: {
    setAgent: (state, action) => {
      state.selectedAgent = action.payload;
    },
    clearAgent: (state) => {
      state.selectedAgent = null;
    },
  },
});

export const { setAgent, clearAgent } = agentSlice.actions;
export default agentSlice.reducer;
